module.exports = __webpack_public_path__ + "media/images/top/img_pickup_mukan-a98af9090465dcf5d66d4b30452ff5b8.webp";